// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

// Variables pour gérer le debounce et éviter les requêtes multiples
let filterTimeout = null;
let isFilterLoading = false;
let abortController = null;

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	*
	* @param {string} url_filters - The URL parameters for the filters.
*/
async function refreshCollectionPageWithFilters(url_filters) {
    // Si une requête est déjà en cours, l'annuler pour la remplacer par celle-ci
    if (abortController) {
        abortController.abort();
    }

    isFilterLoading = true;
    abortController = new AbortController();
    let currentUrl = '//' + location.host + location.pathname;

    try {
        const response = await fetch(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`, {
            signal: abortController.signal
        });

        if (!response.ok) {
            throw new Error(`Erreur HTTP ${response.status} lors du chargement des filtres`);
        }

        const newPageString = await response.text();

        // Créer un nouvel élément DIV pour insérer le HTML récupéré
        let newPageEl = document.createElement('DIV');
        newPageEl.innerHTML = newPageString;

        // Mise à jour des articles de la collection avec les nouveaux filtres
        var newSection = newPageEl.querySelector('.mm-grid-container-card');
        if (newSection) {
            document.querySelector('.mm-grid-container-card').innerHTML = newSection.innerHTML;
        }

        // Mise à jour des filtres actifs
        var activeFilters = newPageEl.querySelectorAll('.active-filters');
        if (activeFilters.length > 0) {
            var newActiveFilters = document.querySelectorAll('.active-filters');
            activeFilters.forEach(function (activeFilter, index) {
                if (newActiveFilters[index]) {
                    newActiveFilters[index].innerHTML = activeFilter.innerHTML;
                }
            });
        }

        // Mise à jour des autres éléments avec la classe 'mm-reload'
        var reloadElems = newPageEl.querySelectorAll('.mm-reload');
        if (reloadElems.length > 0) {
            var newElems = document.querySelectorAll('.mm-reload');
            reloadElems.forEach(function (reloadElem, index) {
                if (newElems[index]) {
                    newElems[index].innerHTML = reloadElem.innerHTML;
                }
            });
        }

        // Mise à jour de l'URL dans l'historique sans recharger la page
        window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
        document.querySelector('.mm-grid-container-card').classList.remove('mm-loading');

        // Scroll tout en haut de la page
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Relancer les quick buy
        mmSetupProductForm();

        // Réinitialise l'observer du bouton Load More après que le DOM soit mis à jour
        requestAnimationFrame(() => {
            // Réinitialiser le numéro de page à 1 après un filtrage
            const loadMoreBtn = document.getElementById('load-more-btn');
            if (loadMoreBtn) {
                loadMoreBtn.dataset.page = '1';
            }

            if (window.reinitMMLoadMore) {
                window.reinitMMLoadMore();
            }
        });

        isFilterLoading = false;
        abortController = null;
    } catch (error) {
        // Ne pas logger les erreurs d'annulation (AbortError)
        if (error.name !== 'AbortError') {
            console.error('Erreur lors du chargement des filtres:', error);
        }
        document.querySelector('.mm-grid-container-card').classList.remove('mm-loading');
        isFilterLoading = false;
        abortController = null;
    }
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	* 
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-grid-collection');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	* 
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
* Keep every checkbox sharing the same name/value in sync. The sidebar filter form isn't part of
* the AJAX swap in refreshCollectionPageWithFilters, so checkboxes rendered outside of it (mobile
* collection filter chips, age modal) would otherwise drift out of sync with their sidebar
* counterpart representing the same filter value.
	*
	* @param {HTMLInputElement} changedInput - The checkbox that just changed.
*/
function mmSyncFilterCheckboxState(changedInput) {
    if (!changedInput || changedInput.type !== 'checkbox' || !changedInput.name) {
        return;
    }

    var selector = 'input[type="checkbox"][name="' + CSS.escape(changedInput.name) + '"][value="' + CSS.escape(changedInput.value) + '"]';
    document.querySelectorAll(selector).forEach(function (input) {
        if (input !== changedInput) {
            input.checked = changedInput.checked;
        }
    });
}

/*********************************************************************************************
* Check for changes in the filter inputs and submit the form if changes are detected.
	*
*/
function checkForChanges() {
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');

    // Ajouter un listener sur chaque input pour détecter les changements
    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            mmSyncFilterCheckboxState(this);
            fakeSubmitForm();
        });
    });
}

/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	* 
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    hiddenSelect.value = select.value;
    fakeSubmitForm();
}

/*********************************************************************************************
* Adds a listener on the change of select for sorting
	* 
*/
// document.querySelector('.sort_by').addEventListener('change', function(e) {
//     var value = e.target.value;
//     Shopify.queryParams.sort_by = value;
//     location.search = new URLSearchParams(Shopify.queryParams).toString();
// });

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    // Annuler le timeout précédent si existant (debounce)
    if (filterTimeout) {
        clearTimeout(filterTimeout);
    }

    // Attendre 300ms après le dernier changement avant de filtrer
    filterTimeout = setTimeout(() => {
        let form = document.getElementById("collectionFacetsForm");
        let url_filters = new URLSearchParams(new FormData(form)).toString();
        document.querySelector('.mm-grid-container-card').classList.add('mm-loading');

        // Rafraîchir la collection avec les filtres
        refreshCollectionPageWithFilters(url_filters);
    }, 300);
}

/*********************************************************************************************
* Open the mobile filters drawer.
	*
*/
function mmOpenFiltersMobile() {
    if (window.innerWidth <= 768) {
        var wrapperMobile = document.querySelector('.mm-grid-container-filter');
        wrapperMobile.classList.add('mm-open');
        document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
    }
}

/*********************************************************************************************
* Close the mobile filters drawer.
	*
*/
function mmCloseFiltersMobile() {
    if (window.innerWidth <= 768) {
        var wrapperMobile = document.querySelector('.mm-grid-container-filter');
        wrapperMobile.classList.remove('mm-open');
        document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
    }
}

/*********************************************************************************************
* Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
	* 
*/
function mmCheckDrawer() {
    if (window.innerWidth <= 768) {
        var currentUrl = document.location.href.indexOf('?open_filters');
        if (currentUrl !== -1) {
            mmOpenFiltersMobile();
        }
    }
}

/*********************************************************************************************
* Toggle the accordion state for filters. 
	* Automatically opens the first three by default.
*/
function mmFiltersAccordeons() {
    const filtersHeaders = document.querySelectorAll('.mm-cf-tag-filter-header');

    filtersHeaders.forEach(function(filtersHeader, index) {
        // Activer les trois premiers filtres par défaut
        if (index < 2) {
            filtersHeader.classList.add('mm-active');
        }

        // Ajoute un événement de clic pour ouvrir/fermer les filtres
        filtersHeader.addEventListener('click', function() {
            filtersHeader.classList.toggle('mm-active');
        });
    });
}

/*********************************************************************************************
* Functions for handling price range sliders.
	*
*/
// const minRange = document.getElementById('min-range');
// const maxRange = document.getElementById('max-range');
// const sliderTrack = document.querySelector('.slider-track');
// const minRangeValue = document.getElementById('min-range-value');
// const maxRangeValue = document.getElementById('max-range-value');

/*********************************************************************************************
* Update the visual representation of the price range sliders and track.
	*
*/
// function updateRange() {
//     const minValue = parseInt(minRange.value, 10); 
//     const maxValue = parseInt(maxRange.value, 10);

//     // Affiche les valeurs min et max sans virgules
//     minRangeValue.querySelector('.price-min-value').innerHTML = minValue;
//     maxRangeValue.querySelector('.price-max-value').innerHTML = maxValue;
    
//     // Calcul des pourcentages pour le fond de la track
//     const minPercent = (minValue / minRange.max) * 100;
//     const maxPercent = (maxValue / maxRange.max) * 100;

//     // Mise à jour du fond de la track pour refléter la plage de prix sélectionnée
//     sliderTrack.style.background = `linear-gradient(to right, #ddd ${minPercent}%, var(--black-900) ${minPercent}%, var(--black-900) ${maxPercent}%, #ddd ${maxPercent}%)`;

//     // Ajuste la largeur des valeurs min et max sur le slider
//     minRangeValue.style.width = `calc(${minPercent}%)`;
//     maxRangeValue.style.width = `calc(${maxPercent}%)`;
// }

/*********************************************************************************************
* Event listeners for price sliders
	*
*/
// minRange.addEventListener('input', function() {
//     if (parseInt(minRange.value) > parseInt(maxRange.value) - 10) {
//         minRange.value = maxRange.value - 10;
//     }
//     updateRange();
// });

// maxRange.addEventListener('input', function() {
//     if (parseInt(maxRange.value) < parseInt(minRange.value) + 10) {
//         maxRange.value = parseInt(minRange.value) + 10;
//     }
//     updateRange();
// });

/*********************************************************************************************
* Hide the sticky mobile filter CTA once the footer comes into view, and bring it back
* when scrolling back up away from the footer.
	*
*/
function mmInitStickyFilterCtaVisibility() {
    const stickyCta = document.querySelector('.mm-sticky-filter-cta');
    const footer = document.querySelector('.mm-footer-container');

    if (!stickyCta || !footer) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(function (entry) {
            stickyCta.classList.toggle('mm-sticky-filter-cta--hidden', entry.isIntersecting);
        });
    }, {
        root: null,
        threshold: 0
    });

    observer.observe(footer);
}

/*********************************************************************************************
* Initialize the Splide carousel for the mobile sub-collection filter chips.
	*
*/
function mmInitSplideCollectionFilters() {
    const splideElem = document.querySelector('.mm-grid-container-mobile-filter-labels');

    if (splideElem && typeof Splide !== 'undefined') {
        const splide = new Splide(splideElem, {
            type: 'slide',
            autoWidth: true,
            perMove: 1,
            gap: 8,
            arrows: false,
            pagination: false,
            padding: { right: 16 },
        }).mount();

        // Refresh once fonts/images finish loading: autoWidth measures slide widths at mount
        // time, so a font swap or a chip picto loading afterward can widen the last slide
        // beyond the scroll range Splide already computed, clipping it.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => splide.refresh());
        }
        window.addEventListener('load', () => splide.refresh());
    }
}

/*********************************************************************************************
* Open the age filter modal (mobile).
	*
*/
function mmOpenAgeModal() {
    const backdrop = document.querySelector('.mm-age-modal-backdrop');
    const modal = document.querySelector('.mm-age-modal');

    if (!backdrop || !modal) {
        return;
    }

    backdrop.classList.add('mm-open');
    modal.classList.add('mm-open');
    document.querySelector('html').classList.add('stop-scrolling');

    if (window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.gsap.fromTo(
            modal,
            { y: '100%' },
            { y: '0%', duration: 0.55, ease: 'power3.out' }
        );
    }
}

/*********************************************************************************************
* Close the age filter modal (mobile).
	*
*/
function mmCloseAgeModal() {
    const backdrop = document.querySelector('.mm-age-modal-backdrop');
    const modal = document.querySelector('.mm-age-modal');

    if (!backdrop || !modal) {
        return;
    }

    // Clear any inline transform GSAP left behind so the CSS closing transition can take over
    if (window.gsap) {
        window.gsap.set(modal, { clearProps: 'transform' });
    }

    // Force a reflow so the browser registers the cleared transform above before the
    // class is removed below, otherwise both changes can collapse into one repaint
    // and the closing transition never gets a starting point to animate from.
    void modal.offsetHeight;

    modal.classList.remove('mm-open');
    backdrop.classList.remove('mm-open');
    document.querySelector('html').classList.remove('stop-scrolling');
}

/*********************************************************************************************
* Submit the facets form whenever an age filter checkbox changes. These inputs live outside
* the <form> (associated via the `form` attribute), so they aren't covered by checkForChanges().
	*
*/
function mmSetupAgeFilterInputs() {
    const inputs = document.querySelectorAll('.mm-age-modal-input');

    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            mmSyncFilterCheckboxState(this);
            fakeSubmitForm();
        });
    });
}

/*********************************************************************************************
* Submit the facets form whenever a mobile collection filter chip is checked/unchecked. These
* inputs live outside the <form> (associated via the `form` attribute), so several collections
* can be combined additively instead of navigating away, and aren't covered by checkForChanges().
	*
*/
function mmSetupCollectionFilterInputs() {
    const inputs = document.querySelectorAll('.mm-collection-filter-checkbox');

    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            mmSyncFilterCheckboxState(this);
            fakeSubmitForm();
        });
    });
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
	mmFiltersAccordeons();
	mmInitStickyFilterCtaVisibility();
	mmInitSplideCollectionFilters();
	mmSetupAgeFilterInputs();
	mmSetupCollectionFilterInputs();
	// updateRange();
});
